/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

import {getTreeListByDictType} from '@/api/dict';

const baseURL = process.env.VUE_APP_BASE_API;

/**
 * 对象数组根据时间排序
 *
 * @param list 要排序的数组
 * @param timeField 时间字段名 time（默认）
 * @param order 排序方式 desc倒序（默认） asc正序
 */
export function listSortByTime(list, timeField, order) {
    try {
        let sortBy = order ? order : "desc";
        let time = timeField ? timeField : "time";
        if (sortBy == "asc") {
            list.sort((a, b) => a[time].localeCompare(b[time]));
        } else if (sortBy == "desc") {
            list.sort((b, a) => a[time].localeCompare(b[time]));
        }
    } catch (e) {
        console.error("日期字段存在非法日期，排序失败！");
    }
}

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange(params, dateRange) {
    var search = params;
    search.beginTime = "";
    search.endTime = "";
    if (null != dateRange && '' != dateRange) {
        search.beginTime = this.dateRange[0];
        search.endTime = this.dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].dictValue == ('' + value)) {
            actions.push(datas[key].dictLabel);
            return true;
        }
    })
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    var actions = [];
    var currentSeparator = undefined === separator ? "," : separator;
    var temp = value.split(currentSeparator);
    Object.keys(value.split(currentSeparator)).some((val) => {
        Object.keys(datas).some((key) => {
            if (datas[key].dictValue == ('' + temp[val])) {
                actions.push(datas[key].dictLabel + currentSeparator);
            }
        })
    })
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments, flag = true, i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
    id = id || 'id'
    parentId = parentId || 'parentId'
    children = children || 'children'
    rootId = rootId || Math.min.apply(Math, data.map(item => {
        return item[parentId]
    })) || 0
    //对源数据深度克隆
    const cloneData = JSON.parse(JSON.stringify(data))
    //循环所有项
    const treeData = cloneData.filter(father => {
        let branchArr = cloneData.filter(child => {
            //返回每一项的子级数组
            return father[id] === child[parentId]
        });
        branchArr.length > 0 ? father.children = branchArr : '';
        //返回第一层
        return father[parentId] === rootId;
    });
    return treeData != '' ? treeData : data;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = ''
    Object.keys(params).forEach((key) => {
        if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
        }
    })
    return result
}

/**
 * 判断权限字符串
 * @param value         权限字符串
 * @returns {boolean}   是否拥有该权限
 */
export function judgePermission(value) {
    let permissions = window.localStorage.getItem("loginUserInfo");
    permissions = JSON.parse(permissions).permissions;
    if (value && typeof (value) == 'string' && value.length > 0) {
        const hasPermissions = permissions.includes(value);
        if (!hasPermissions) {
            return false;
        } else {
            return true;
        }
    } else {
        throw new Error(`请设置操作权限标签值`)
    }
}

/**
 * 将list的属性值转为int类型
 * @param list    list
 * @param key    属性
 * @returns {Array}    转换后的list
 */
export function listParseIntByKey(list, key) {
    let ret = [];
    list.forEach(item => {
        item[key] = parseInt(item[key]);
        ret.push(item)
    });
    return ret;
}

/**
 * 将字典值转换为字典名称
 * @param dictList    字典列表
 * @param value        字典值
 * @returns {string}    字典名称
 */
export function dictFormatter(dictList, value) {
    let item = dictList.find(item => item.value == value);
    return item ? item.label : '';
}

/** 获取地区字典 */
export function getRegionCode() {
    return new Promise((resolve, reject) => {
        let regionCode = window.localStorage.getItem("dict_region_code");
        if (!regionCode) {
            getTreeListByDictType("region_code").then((res) => {
                window.localStorage.setItem('dict_region_code', JSON.stringify(res.data));
                resolve(res.data);
            });
        } else {
            resolve(JSON.parse(regionCode));
        }
    });
}

/**
 * 格式化地区编码
 * @param regionDict    地区字典
 * @param addressObj    地区对象
 * @returns {string}
 */
export function formatterRegionCode(regionDict, addressObj) {
    let address = "";
    let province = regionDict.find(item => item.value == addressObj.provinceCode);
    if (province && province.label) {
        address += province.label;
        let city = province.children.find(item => item.value == addressObj.cityCode);
        if (city && city.label) {
            address += city.label;
            let region = city.children.find(item => item.value == addressObj.regionCode);
            if (region && region.label) {
                address += region.label;
            }
        }
    }
    return address;
}
